module.exports = __webpack_public_path__ + "img/admin-bg-light.5d3b291a.png";